// Product recommendations from LK_ProgramMapper / AI_App_Context via program router

import {
  matchProgramsFromRouter,
  getRouterRowByRawCode,
  mapRowToProgram,
  getDistinctRouterProgramCount,
  getProgramsByCategory,
} from './programRouterMatch.js';

/**
 * @param {Record<string, string>} answers — productRecommendation from Redux
 * @returns {Array<object>} Top program variants (up to 3 distinct router codes)
 */
export function calculateRecommendations(answers) {
  return matchProgramsFromRouter(answers);
}

export function getProgramById(programId) {
  const row = getRouterRowByRawCode(programId);
  return row ? mapRowToProgram(row) : null;
}

export function getTotalProgramCount() {
  return getDistinctRouterProgramCount();
}

export { getProgramsByCategory };
